import React from 'react';

const LockIcon = ({ size = '24', fill = '#7B7979' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 21.5V8.50001H7.5V6.50001C7.5 5.25131 7.93782 4.18915 8.81345 3.31351C9.6891 2.43788 10.7513 2.00006 12 2.00006C13.2487 2.00006 14.3109 2.43788 15.1865 3.31351C16.0621 4.18915 16.5 5.25131 16.5 6.50001V8.50001H19.5V21.5H4.5ZM5.99997 20H18V9.99999H5.99997V20ZM12 16.75C12.4859 16.75 12.899 16.5798 13.2394 16.2394C13.5798 15.899 13.75 15.4859 13.75 15C13.75 14.5141 13.5798 14.101 13.2394 13.7606C12.899 13.4202 12.4859 13.25 12 13.25C11.5141 13.25 11.1009 13.4202 10.7606 13.7606C10.4202 14.101 10.25 14.5141 10.25 15C10.25 15.4859 10.4202 15.899 10.7606 16.2394C11.1009 16.5798 11.5141 16.75 12 16.75ZM8.99997 8.50001H15V6.50001C15 5.66668 14.7083 4.95834 14.125 4.37501C13.5416 3.79168 12.8333 3.50001 12 3.50001C11.1666 3.50001 10.4583 3.79168 9.87497 4.37501C9.29164 4.95834 8.99997 5.66668 8.99997 6.50001V8.50001Z"
        fill={fill}
      />
    </svg>
  );
};

export default LockIcon;
